import styled from '@emotion/styled';

export const ListLayoutContainer = styled.div`
  background: white;
`;
